export default __webpack_public_path__ + "static/media/UNI.920e8665.svg";